<template>
  <div class="pound-page-content">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>磅单示例</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-box toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">示例名称</span>
        <el-input v-model.trim="filter.templateName" style="width: 170px" placeholder="请输入示例名称"></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="item-label">装货地址</span>
        <region style="width: 150px" ref="regionFH" v-on:back-region="selectSourceCode"></region>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">卸货地址</span>
        <region ref="regionXH" style="width: 150px" v-on:back-region="selectTargetCode"></region>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="item-label">任务单类型</span>
        <el-select style="width: 220px" v-model="filter.transportMode" placeholder="请选择" class="track-elselect">
          <el-option v-for="(item, idx) in transportModeList" :label="item.label" :value="item.value" :key="idx">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-4">
        <span class="demonstration">示例时间</span>
        <el-date-picker
          v-model="filter.applyTimeBegin"
          type="datetime"
          style="width: 220px"
          value-format="timestamp"
          :clearable="false"
          placeholder="选择开始日期"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.applyTimeEnd"
          type="datetime"
          style="width: 220px"
          value-format="timestamp"
          :clearable="false"
          placeholder="选择结束日期"
          default-time="23:59:59"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-5">
        <span class="item-label">审核状态</span>
        <el-select style="width: 220px" v-model="filter.state" placeholder="请选择" class="track-elselect">
          <el-option v-for="(item, idx) in stateList" :label="item.label" :value="item.value" :key="idx"> </el-option>
        </el-select>
      </div>

      <div class="toolbar-item" id="auto-6">
        <el-button type="primary" round size="small" @click="hanldeSearch">筛选</el-button>
        <el-button @click="handleReset" id="auto-7">重置</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 磅单示例管理列表 </span>
      </div>
      <div class="fr">
        <el-button id="auto-8" size="small" type="primary" @click="handleAdd">添加</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-9">
      <el-table :data="tableData.list" border>
        <el-table-column label="示例名称" width="120" prop="templateName"></el-table-column>

        <el-table-column prop="loadAddress.addressDetail" label="装货地址" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="unloadAddress.addressDetail"
          label="卸货地址"
          class-name="pointer"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column label="任务单类型" width="120" class-name="pointer" prop="transportMode">
          <template v-slot="scope">
            <span v-if="scope.row.transportMode == 21">批量上传任务单</span>
            <span v-if="scope.row.transportMode == 22">按趟上传任务单</span>
          </template>
        </el-table-column>
        <el-table-column label="示例时间" width="160" class-name="pointer">
          <template v-slot="scope">
            <div>{{ scope.row.applyTime | stamp2TextDateFull }}</div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="130" class-name="pointer">
          <template v-slot="scope">
            <span v-if="scope.row.state == 10">待审核</span>
            <span v-if="scope.row.state == 20">审核未通过</span>
            <span v-if="scope.row.state == 30">审核通过</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="120">
          <template v-slot="scope">
            <el-button
              v-if="scope.row.state != 10"
              size="small"
              type="text"
              class="font-blue"
              @click="hanldeUpdate(scope.row)"
              >修改磅单</el-button
            >
            <el-button size="small" class="font-red" type="text" @click="hanldeDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.count"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!--编辑磅单示例-->
    <el-dialog title="修改磅单示例" :visible.sync="poundDialog" custom-class="pound-Dialog">
      <el-form :inline="true" :model="form" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="示例名称" prop="templateName">
          <el-input
            v-model.trim="form.templateName"
            auto-complete="off"
            :maxlength="32"
            placeholder="请输入示例名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务单类型" prop="transportMode">
          <el-select v-model="form.transportMode" placeholder="请选择任务单类型" class="track-elselect" disabled>
            <el-option v-for="(item, idx) in transportModeList" :label="item.label" :value="item.value" :key="idx">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="未通过原因：" v-if="auditState == 20" class="wrap">
          <span class="font-red">{{ backReason }}</span>
        </el-form-item>

        <el-form-item label="装货磅单变更时间" prop="loadPoundUpdateTime">
          <el-date-picker
            v-model="form.loadPoundUpdateTime"
            type="datetime"
            style="width: 190px"
            value-format="timestamp"
            :clearable="false"
            placeholder="请选择变更时间"
            :disabled="!loadPoundEditStatus"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="卸货磅单变更时间" prop="unloadPoundUpdateTime">
          <el-date-picker
            v-model="form.unloadPoundUpdateTime"
            type="datetime"
            style="width: 190px"
            value-format="timestamp"
            :clearable="false"
            placeholder="请选择变更时间"
            :disabled="!unloaPoundEditStatus"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="装货磅单">
          <fe-upload
            :default-files="loadPoundList"
            :limit="1"
            :hidetip="true"
            ref="loadPoundRef"
            @remove="handleRemovedLoad"
          />
        </el-form-item>
        <el-form-item label="卸货磅单">
          <fe-upload
            :default-files="unloadPoundList"
            :limit="1"
            :hidetip="true"
            ref="unloadPoundRef"
            @remove="handleRemovedUnload"
          />
        </el-form-item>
      </el-form>
      <div class="pound-tip">* 请上传机打磅单图片</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="poundDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm('form')">更新</el-button>
      </div>
    </el-dialog>

    <el-dialog title="磅单修改确认" :visible.sync="poundTemplateTip" custom-class="dia-tiny">
      <div>如未通过审核，可能会影响该配置货源的运单审核，是否确认变更</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="poundTemplateTip = false">否</el-button>
        <el-button type="primary" @click="handleSave">是</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:8
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
import FeUpload from '@/components/FeUpload';
import { getFileUrlPrefix } from '@/utils';
export default {
  components: {
    FeUpload
  },
  data() {
    return {
      filter: {
        templateName: '',
        loadRegionCode: '',
        unloadRegionCode: '',
        transportMode: null,
        applyTimeBegin: null,
        applyTimeEnd: null,
        state: null
      },
      pageSize: 20,
      currentPage: 1,
      cache: {}, //缓存筛选条件
      tableData: {
        list: [],
        count: 0
      },
      poundDialog: false,
      poundId: '',
      form: {
        templateName: '',
        transportMode: '',
        loadPoundUpdateTime: '',
        unloadPoundUpdateTime: '',
        loadAddressCode: '',
        unloadAddressCode: ''
      },
      loadPoundEditStatus: false,
      unloaPoundEditStatus: false,
      backReason: '',
      auditState: '',
      loadPoundList: [],
      unloadPoundList: [],
      rules: {},
      transportModeList: [
        { label: '批量上传任务单', value: 21 },
        { label: '按趟上传任务单', value: 22 }
      ],
      stateList: [
        { label: '待审核', value: 10 },
        { label: '审核未通过 ', value: 20 },
        { label: '审核通过 ', value: 30 }
      ],
      urlPrefix: '',
      poundTemplateTip: false,
      submitData: {}
    };
  },
  async created() {
    this.hanldeSearch();
    this.urlPrefix = await getFileUrlPrefix();
  },
  methods: {
    hanldeSearch() {
      if (
        this.filter.applyTimeBegin &&
        this.filter.applyTimeEnd &&
        new Date(this.filter.applyTimeBegin).getTime() > new Date(this.filter.applyTimeEnd).getTime()
      ) {
        this.$message.error('开始时间不能大于结束时间');
        return false;
      }
      this.cache = {
        ...this.filter
      };
      this.currentPage = 1;
      this.axiosRequest();
    },
    handleReset() {
      this.filter = {
        templateName: '',
        loadRegionCode: '',
        unloadRegionCode: '',
        transportMode: null,
        applyTimeBegin: null,
        applyTimeEnd: null,
        state: null
      };
      this.$refs.regionFH.resetData();
      this.$refs.regionXH.resetData();
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      let options = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        ...this.cache
      };
      axios.post(api.queryPoundTemplate, options).then(res => {
        this.tableData.list = res.data.data;
        this.tableData.count = res.data.total;
      });
    },
    // 选择装货城市
    selectSourceCode(data) {
      this.filter.loadRegionCode = data != null && data.regionCode ? data.regionCode : '';
    },
    // 选择卸货城市
    selectTargetCode(data) {
      this.filter.unloadRegionCode = data != null && data.regionCode ? data.regionCode : '';
    },
    hanldeUpdate(item) {
      this.form.templateName = item.templateName;
      this.form.transportMode = item.transportMode;
      this.form.loadPoundUpdateTime = item.loadPoundUpdateTime == 0 ? null : item.loadPoundUpdateTime;
      this.form.unloadPoundUpdateTime = item.unloadPoundUpdateTime == 0 ? null : item.unloadPoundUpdateTime;
      this.form.loadAddressCode = item.loadAddress.addressCode;
      this.form.unloadAddressCode = item.unloadAddress.addressCode;
      this.loadPoundList = item.loadPound ? [this.urlPrefix + item.loadPound] : [];
      this.unloadPoundList = item.unloadPound ? [this.urlPrefix + item.unloadPound] : [];
      this.loadPoundEditStatus = item.loadPound && item.loadPoundUpdateTime ? false : true;
      this.unloaPoundEditStatus = item.unloadPound && item.unloadPoundUpdateTime ? false : true;
      this.backReason = item.backReason;
      this.auditState = item.state;
      this.poundId = item.id;
      this.poundDialog = true;
    },
    handleRemoveFix(url) {
      return url.replace(/^http(s)?:\/\/.+\.com(\/)?/, '');
    },
    hanldeDel(item) {
      this.$confirm('删除后不可恢复，是否确认删除?', '磅单示例删除确认', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          axios.post(api.deletePoundTemplate, { poundTemplateId: item.id }).then(res => {
            this.hanldeSearch();
          });
        })
        .catch(() => {});
    },
    handleSubmitForm() {
      let loadPoundList = this.$refs.loadPoundRef.getUploadFiles().map(el => this.handleRemoveFix(el));
      let unloadPoundList = this.$refs.unloadPoundRef.getUploadFiles().map(el => this.handleRemoveFix(el));
      let options = {
        ...this.form,
        id: this.poundId,
        loadPound: loadPoundList.join(','),
        unloadPound: unloadPoundList.join(',')
      };
      if (!options.templateName) {
        this.$message.error('请输入示例名称');
        return;
      }
      if (!options.loadPound && !options.unloadPound) {
        this.$message.error('请上传装（卸）货图片');
        return;
      }
      if (this.loadPoundEditStatus && options.loadPound && !this.form.loadPoundUpdateTime) {
        this.$message.error('请选择装货磅单变更时间');
        return;
      }
      if (this.unloaPoundEditStatus && options.unloadPound && !this.form.unloadPoundUpdateTime) {
        this.$message.error('请选择装卸货磅单变更时间');
        return;
      }
      this.submitData = { ...options };
      if ((options.loadPound && this.loadPoundEditStatus) || (options.unloadPound && this.unloaPoundEditStatus)) {
        this.poundTemplateTip = true;
      } else {
        this.handleSave();
      }
    },
    handleSave() {
      axios.post(api.savePoundTemplate, this.submitData).then(res => {
        this.poundDialog = false;
        if (this.poundTemplateTip) this.poundTemplateTip = false;
        this.$message.success(res.message || '操作成功');
        this.hanldeSearch();
      });
    },
    handleRemovedLoad() {
      this.loadPoundEditStatus = true;
      this.form.loadPoundUpdateTime = null;
    },
    handleRemovedUnload() {
      this.unloaPoundEditStatus = true;
      this.form.unloadPoundUpdateTime = null;
    },
    handleAdd() {
      this.$router.push({ path: '/pound/example/add' });
    }
  }
};
</script>
<style lang="postcss">
.pound-page-content {
  .pound-Dialog {
    width: 760px;
    .el-form {
      width: 800px;
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        width: 350px;
        &.wrap {
          width: 700px;
        }
      }
    }
    .pound-tip {
      padding-left: 10px;
      height: 32px;
      line-height: 32px;
      background: linear-gradient(270deg, #ffffff 0%, #fff8f2 100%);
      border-radius: 2px;
      color: #ff9900;
    }
  }
}
</style>
